import connect from './src/connect.js';
import Provider from './src/Provider.js';

export {Provider, connect};



/** WEBPACK FOOTER **
 ** ./index.js
 **/